export default __webpack_public_path__ + "static/moneybus_medium_1-893c544e6a015f6b39bd8cc0d06905a7.webp";